export const isMainChapter = (warranty: string) => {
  const lower = warranty.toLowerCase();
  return (
    lower.startsWith('chapitre') ||
    lower.includes('f.a.q') ||
    lower.includes('assurance de personne')
  );
};
